import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext, useFieldArray, Controller } from 'react-hook-form';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import { RHFAutocomplete, RHFTextField } from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import { InputAdornment, Typography } from '@mui/material';

export default function EmpRefNewEditForm({ desgRefData, countryArr, filterPhoneCode }) {
  const { control, setValue, watch, resetField } = useFormContext();

  const { fields, append, remove } = useFieldArray({
    control,
    name: 'empRef',
  });

  const handleAdd = () => {
    append({
      refSrno: 0,
      refNm: '',
      refOrgNm: '',
      refdesig: null,
      refEmail: '',
      refContact: '',
      refContactPhncode: null,
    });
  };

  const handleRemove = (index) => {
    remove(index);
  };
  return (
    <>
      <Box
        mt={4}
        rowGap={3}
        columnGap={2}
        display="grid"
        gridTemplateColumns={{
          xs: 'repeat(1, 1fr)',
          sm: 'repeat(2, 1fr)',
        }}
        mb={3}
      >
        {/* <Typography variant="subtitle2" sx={{ mb: 3 }}>
          References Details:
        </Typography> */}
        <Box>
          <Typography variant="h6" sx={{ color: 'text.disabled', mb: 3 }}>
            Reference Details:
          </Typography>
        </Box>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          alignItems={{ xs: 'flex-end', md: 'center' }}
          justifyContent="flex-end"
        >
          <Button
            size="small"
            color="primary"
            startIcon={<Iconify icon="mingcute:add-line" />}
            onClick={handleAdd}
            sx={{ flexShrink: 0, minWidth: '140px', justifyContent: 'flex-start' }}
          >
            Add References
          </Button>
        </Stack>
      </Box>
      <Stack divider={<Divider sx={{ borderStyle: 'dashed' }} />} spacing={2}>
        {fields.map((item, index) => (
          <Stack key={item.id} spacing={1.5} sx={{
            p: 1,
            borderRadius: 1,
            bgcolor: item.fromCandidate ? 'grey.100' : 'transparent',
            border: item.fromCandidate ? '0.5px dashed grey' : 'none',
          }} >
            <Typography variant="subtitle2" sx={{ color: 'primary', mb: 1 }}>
              References {index + 1}:
            </Typography>
            <Box
              rowGap={3}
              columnGap={2}
              display="grid"
              gridTemplateColumns={{
                xs: 'repeat(1, 1fr)',
                sm: 'repeat(2, 1fr)',
              }}
            >
              <Box sx={{ display: { xs: 'block', sm: 'none' } }}>
                <RHFTextField name={`empRef[${index}].refSrno`} />
              </Box>
              <RHFTextField
                name={`empRef[${index}].refNm`}
                label={
                  <div>
                    Name<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                  </div>
                }
              />
              <RHFTextField
                name={`empRef[${index}].refOrgNm`}
                label={
                  <div>
                    Organization Name<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                  </div>
                }
              />
              <Stack spacing={1.5}>
                <RHFAutocomplete
                  name={`empRef[${index}].refdesig`}
                  placeholder="Select designation"
                  label={
                    <div>
                      Designation<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                    </div>
                  }
                  options={desgRefData}
                  showPlusIcon
                  getOptionLabel={(option) => option.masterName}
                  renderOption={(props, option) => (
                    <li {...props} key={option.masterId}>
                      {option.masterName}
                    </li>
                  )}
                />
              </Stack>
              <RHFTextField
                name={`empRef[${index}].refEmail`}
                label={
                  <div>
                    Email<span style={{ color: 'red', fontWeight: 'bolder' }}> *</span>
                  </div>
                }
              />
              <RHFTextField
                type="number"
                name={`empRef[${index}].refContact`}
                label="Contact Number"
                onWheel={(e) => e.target.blur()}
                InputLabelProps={{ shrink: true }}
                sx={{ mt: -1 }}
              />
            </Box>

            <Stack
              direction={{ xs: 'column', md: 'row' }}
              alignItems={{ xs: 'flex-end', md: 'center' }}
              justifyContent="flex-end"
            >
              <Button
                size="small"
                color="error"
                startIcon={<Iconify icon="solar:trash-bin-trash-bold" />}
                onClick={() => handleRemove(index)}
              >
                Remove
              </Button>
            </Stack>
          </Stack>
        ))}
      </Stack>
    </>
  );
}
EmpRefNewEditForm.propTypes = {
  desgRefData: PropTypes.array,
  countryArr: PropTypes.array,
  filterPhoneCode: PropTypes.func,
};
